// 成长体系新人地图任务Confirmation of Available Class Schedule
import { getScheduleList } from '@/api/dashboard'
import { formatDate } from '@/utils/date.js'
const classSchedule = {
  namespaced: true,
  state:{
    events: [],
    initEvents: [],
    selects:[],
    loading: false,
    hourRate:0,
    currency:'',
    weekRateTotal:0
  },
  mutations:{
    SET_LOADING: (state, loading) => {
        state.loading = loading
    },
    SET_EVENTS: (state, events) => {
        state.events = events
        state.initEvents = Object.assign([],events)
    },
    UPDATE_EVENTS: (state, array) => {
      let arr = state.events.map(i => { //设置单个日期状态
        if (i.TimeStart === array.TimeStart) {
          if (i.Status === 0) {
            i.Status = 1
          } else if (i.Status === 1) {
            i.Status = 0
          }
          array.Status=i.Status
        }
        return i
      })
      if(array.IsBusy){
          if(array.Status==0){
              var check=arr.find(t=>formatDate(t.TimeStart,'yyyy/MM/dd')==formatDate(array.TimeStart,'yyyy/MM/dd') && formatDate(t.TimeStart,'hh:mm')=='05:30' && t.Status==1)
              if(check){
                  for(var i=0;i<arr.length;i++){
                      if(formatDate(arr[i].TimeStart,'yyyy/MM/dd')==formatDate(check.TimeStart,'yyyy/MM/dd') && formatDate(arr[i].TimeStart,'hh:mm')=="05:30" ){
                          arr[i].Status=0
                      }
                  }
              }
          }else if(array.Status==1){
              var check=arr.filter(t=>formatDate(t.TimeStart,'yyyy/MM/dd')==formatDate(array.TimeStart,'yyyy/MM/dd') && t.IsBusy && formatDate(t.TimeStart,'hh:mm')!='05:30')
                      .every(t=>t.Status==1)
              if(check){
                  for(var i=0;i<arr.length;i++){
                      if(formatDate(arr[i].TimeStart,'yyyy/MM/dd')==formatDate(array.TimeStart,'yyyy/MM/dd') && formatDate(arr[i].TimeStart,'hh:mm')=="05:30" ){
                          arr[i].Status=1
                      }
                  }
              }
          }
      }
      state.events=arr
    },
    UPDATE_SELECTS: (state) => {
      let arr = state.events.filter(item => 
        item.Status === 1 && formatDate(item.TimeStart,'hh:mm')!="05:30"
      )
      let arr2 = arr.map(v=>{
        return { week: new Date(v.TimeStart).getDay()==0?7:new Date(v.TimeStart).getDay(),timeSpan:formatDate(v.TimeStart,'hh:mm')}
      })
      state.selects = arr2
    },
    UPDATE_BUSY_EVENTS:　(state, flag) => {

      let arr = state.initEvents
      //.filter(t=>t.BusyTimeCheckFlag==flag && t.BusyTimeCheck)
      .map(i => {
        if (i.IsBusy && formatDate(i.TimeStart,'yyyy/MM/dd')==formatDate(flag,'yyyy/MM/dd') && i.Status == 0 ) {
            i.Status = 1
        }
        if(i.TimeStart==flag){
          i.Status = 1
        }
        return i
      })
      state.events = arr
    },
    UPDATE_BUSY_EVENTS_CANCLE: (state, flag) => {
      let arr = state.initEvents.map(i => {
        if (formatDate(i.TimeStart,'yyyy/MM/dd')==formatDate(flag,'yyyy/MM/dd') && i.Status == 1) {
            i.Status = 0
        }
        return i
      })
      state.events = arr
    },
    SET_HOURRATE:(state,res)=>{
      state.hourRate = res
    },
    SET_CURRENCY:(state,res)=>{
      state.currency = res
    },
    WEEK_RATE_CHANGE:(state,res)=>{
      state.weekRateTotal = res
    }
  },
  actions:{
    async fetchData ({ commit, state }) {
        commit('SET_LOADING', true)
        await getScheduleList()
          .then(res => {
            if(res){
              commit('SET_EVENTS', res.GrowrthScheduleDetail)
              commit('SET_HOURRATE', res.HourRate)
              commit('SET_CURRENCY', res.Currency)
            }
          })
          .finally(() => {
            commit('SET_LOADING', false)
          })
      },
      upEvents ({ commit }, array) {
        commit('UPDATE_EVENTS', array)
        commit('UPDATE_SELECTS', array)
      },
      upBusyTime({ commit }, flag) {
          commit('UPDATE_BUSY_EVENTS', flag)
          commit('UPDATE_SELECTS', flag)
      },
      upBusyTimeCancle({ commit }, flag) {
          commit('UPDATE_BUSY_EVENTS_CANCLE', flag)
          commit('UPDATE_SELECTS', flag)
      },
      weekRateChange({commit},res){
        commit('WEEK_RATE_CHANGE',res)
      }
  },
  getters: {
    events: state => state.events,
    initEvents: state => state.initEvents,
    selects: state => state.selects,
    loading: state => state.loading,
    hourRate: state => state.hourRate,
    currency:state=>state.currency,
  }
}
export default classSchedule